import { Dialog, DialogContent } from '@material-ui/core';
import { noop } from '@thalesrc/js-utils';
import React, { useContext, useState } from 'react';

import { DateRange } from '../../../../api/hs/dashboard/widget/widget.payload';
import { exportNearMissWidgetExport, getNearMissView } from '../../../../api/hs/near-miss-widget';
import IndicatorWrapper from '../../../../Common/IndicatorWrapper';
import { useFetch } from '../../../../utils';
import colors from '../../colors';
import { DialogContext } from '../../dialog.context';
import Header from '../Header';
import NearMissTable from './NearMissTable';

export default () => {
  const {
    nearMiss: { close, opened },
    nearMissDateRange: { dateRange },
  } = useContext(DialogContext);

  const [loading, setLoading] = useState<boolean>(false);
  const { data: nearMiss } = useFetch(() => getNearMissView(new DateRange(dateRange?.start, dateRange?.end)), [], { setLoading });

  const handleExcelExport = () => {
    exportNearMissWidgetExport(new DateRange(dateRange.start, dateRange.end), 'ramak_kala_widget.xlsx').then(noop);
  };

  return (
    <Dialog open={opened} onClose={close} fullWidth maxWidth="md">
      <Header title="Ramak Kala" color={colors.nearMiss} onClick={nearMiss.length > 0 && handleExcelExport} />
      <DialogContent style={{ height: '300px' }}>
        <IndicatorWrapper data={nearMiss} loading={loading} errorMessage="Listelenecek Kayıt Bulunamadı">
          <NearMissTable nearMissData={nearMiss} />
        </IndicatorWrapper>
      </DialogContent>
    </Dialog>
  );
};
